import {
  CreateRoomErrorResponseSchema,
  CreateRoomSuccessResponseSchema,
  type CreateRoomResponse,
} from '../../../../shared/protocol';

export class CreateRoomResponseError extends Error {}

/**
 * The room API is intentionally parsed as text first: a proxy, route, or
 * Worker regression must never turn an empty/non-JSON response into a raw
 * SyntaxError in the UI.
 */
export async function parseCreateRoomResponse(response: Response): Promise<CreateRoomResponse> {
  const raw = await response.text();
  const metadata = {
    method: 'POST',
    url: response.url,
    status: response.status,
    contentType: response.headers.get('content-type'),
    bodyLength: raw.length,
  };

  if (!raw.trim()) {
    console.warn('[ROOM_CREATE_RESPONSE_INVALID]', { ...metadata, reason: 'empty_body' });
    throw new CreateRoomResponseError(`Servidor retornou resposta vazia (HTTP ${response.status}). Tente novamente.`);
  }

  let data: unknown;
  try {
    data = JSON.parse(raw);
  } catch {
    console.warn('[ROOM_CREATE_RESPONSE_INVALID]', { ...metadata, reason: 'invalid_json' });
    throw new CreateRoomResponseError(`Resposta inválida do servidor (HTTP ${response.status}). Tente novamente.`);
  }

  if (response.status >= 200 && response.status < 300) {
    const result = CreateRoomSuccessResponseSchema.safeParse(data);
    if (result.success) return result.data;
    console.warn('[ROOM_CREATE_RESPONSE_INVALID]', { ...metadata, reason: 'invalid_success_contract' });
    throw new CreateRoomResponseError('Resposta do servidor incompleta. Tente novamente.');
  }

  const result = CreateRoomErrorResponseSchema.safeParse(data);
  if (result.success) throw new CreateRoomResponseError(result.data.error.message);
  console.warn('[ROOM_CREATE_RESPONSE_INVALID]', { ...metadata, reason: 'invalid_error_contract' });
  throw new CreateRoomResponseError(`Não foi possível criar a sala (HTTP ${response.status}).`);
}
